import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { Pane, PaneHeader, Button, Icon } from '@folio/stripes/components';

import { MessageList, MessageInput, ConnectionStatus } from '../';

import css from './ChatInterface.css';

const propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  onSendMessage: PropTypes.func.isRequired,
  onClearChat: PropTypes.func,
};

const defaultProps = {
  messages: [],
  isLoading: false,
  onClearChat: () => {},
};

const ChatInterface = ({ messages, isLoading, onSendMessage, onClearChat }) => {
  const intl = useIntl();

  const renderPaneHeader = () => {
    return (
      <PaneHeader
        paneTitle={intl.formatMessage({
          id: 'ui-plugin-smart-help.chat.title',
        })}
        paneSub={<ConnectionStatus />}
        actionMenu={({ onToggle }) => (
          <Button
            buttonStyle="dropdownItem"
            onClick={() => {
              onClearChat();
              onToggle();
            }}
            marginBottom0
          >
            <Icon icon="trash">
              {intl.formatMessage({
                id: 'ui-plugin-smart-help.chat.clearChat',
              })}
            </Icon>
          </Button>
        )}
      />
    );
  };

  return (
    <Pane
      id="smart-help-chat-pane"
      defaultWidth="100%"
      renderHeader={renderPaneHeader}
      paneSub={intl.formatMessage({ id: 'ui-plugin-smart-help.chat.subtitle' })}
    >
      <div className={css.chatContainer}>
        <div className={css.messagesContainer}>
          <MessageList messages={messages} isLoading={isLoading} />
        </div>
        <div className={css.inputContainer}>
          <MessageInput
            onSendMessage={onSendMessage}
            disabled={isLoading}
            placeholder={intl.formatMessage({
              id: 'ui-plugin-smart-help.chat.inputPlaceholder',
            })}
          />
        </div>
      </div>
    </Pane>
  );
};

ChatInterface.propTypes = propTypes;
ChatInterface.defaultProps = defaultProps;

export default ChatInterface;
